import { render, staticRenderFns } from "./staff-loan.vue?vue&type=template&id=3a88cb38&"
import script from "./staff-loan.vue?vue&type=script&lang=js&"
export * from "./staff-loan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports